// @ts-nocheck
/* eslint-disable */
export const locationIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 8.625C18 11.0108 14.4613 17.0308 12.8191 19.6959C12.4387 20.3132 11.5613 20.3132 11.1809 19.6959C9.53873 17.0308 6 11.0108 6 8.625C6 5.5184 8.68629 3 12 3C15.3137 3 18 5.5184 18 8.625Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="8" r="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'location' as const,
};
